import {type Element, type Node} from 'slate';
export interface Paragraph extends Element {
  type: 'paragraph';
  textAlign?: 'center';
}

export const isParagraph = (node: Node): node is Paragraph =>
  node.type === 'paragraph';
